( function( $ ) {
    "use strict";

    var _events = {
        onChangeEntryOverall: function() {
            var $overall = $(this),
                $row = $overall.closest('tr'),
                $bookingEntries = $row.closest('[data-booking-entries]'),
                $id = $row.find('[data-form-control="id"]'),
                $saleTickets = $row.find('[data-sale-tickets]'),
                overall = $overall.val(),
                maxOverall = $saleTickets.data('sale-tickets');

            if (! /^\d+$/.test(overall) || overall > maxOverall) {
                $overall.val($overall.attr('data-value'));
            }

            $bookingEntries.trigger('refresh');
        },

        onRefreshBookingEntries: function() {
            var $bookingEntries = $(this),
                $overallInputs = $bookingEntries.find('[data-form-control="overall"]'),
                $saleTickets = $bookingEntries.find('[data-sale-tickets]'),
                $bookingOverall = $bookingEntries.find('[data-booking-overall]'),
                $bookingOverallPercent = $bookingEntries.find('[data-booking-overall-percent]'),
                $bookingSaleTickets = $bookingEntries.find('[data-booking-sale-tickets]'),
                $bookingProgress = $bookingEntries.find('[data-booking-progress]'),
                quantitiesSum = 0,
                overallsSum = 0,
                bookingOverall = 0,
                bookingSaleTickets = 0;

            $overallInputs.each(function() {
                var $overall = $(this),
                    overall = $overall.val();

                overallsSum += parseInt(overall);
            });

            $bookingOverall.text(isNaN(overallsSum) ? '' : overallsSum);
            $bookingOverallPercent.toggleClass('hidden', isNaN(overallsSum));

            $saleTickets.each(function() {
                bookingSaleTickets += parseInt($(this).data('sale-tickets'));
            });

            $bookingSaleTickets.text(bookingSaleTickets);

            var bookingPercent = (overallsSum / bookingSaleTickets) * 100;

            $bookingProgress.toggleClass('hidden', isNaN(bookingPercent));

            $bookingProgress
                .attr('data-percent', bookingPercent + '%')
                .trigger('progress');
        },

        onChangePeriodBegin: function() {
            var $periodBegin = $(this),
                $periodEnd = $('#representation_period_end');

            if ($periodBegin.val()) {
                if (! $periodEnd.val()) {
                    $periodEnd.val($periodBegin.val());
                } else if ($periodBegin.datepicker('getDate').getTime() > $periodEnd.datepicker('getDate').getTime()) {
                    $periodEnd.val($periodBegin.val());
                }
            } else {
                $periodEnd.trigger('change');
            }
        },

        onChangePeriodEnd: function() {
            var $periodEnd = $(this),
                $periodBegin = $('#representation_period_begin');

            if ($periodEnd.val()) {
                if (! $periodBegin.val()) {
                    $periodBegin.val($periodEnd.val());
                } else if ($periodEnd.datepicker('getDate').getTime() < $periodBegin.datepicker('getDate').getTime()) {
                    $periodBegin.val($periodEnd.val());
                }
            } else {
                $periodBegin.trigger('change');
            }
        },

        onChangePeriodAuto: function() {
            var $periodAuto = $(this),
                $periodBeginInput = $('#representation_period_begin'),
                $periodEndInput = $('#representation_period_end'),
                $periodBeginField = $periodBeginInput.closest('[data-form-field]'),
                $periodEndField = $periodEndInput.closest('[data-form-field]');

            if ($periodAuto.prop('checked')) {
                $periodBeginInput.val('');
                $periodEndInput.val('');
                $periodBeginField.toggleClass('hidden', true);
                $periodEndField.toggleClass('hidden', true);
            } else {
                $periodBeginInput.val($periodBeginInput.data('today'));
                $periodEndInput.val($periodBeginInput.data('today'));
                $periodBeginField.toggleClass('hidden', false);
                $periodEndField.toggleClass('hidden', false);
            }
        },

        onChangeArtistFeeAmount: function() {
            var $artistFeeAmount = $(this),
                $row = $artistFeeAmount.closest('tr'),
                $artistFeeTotal = $row.find('[data-form-control="artistfee_total"]'),
                $artistFeePercentage = $row.find('[data-form-control="artistfee_percentage"]'),
                artistFeeAmount = $artistFeeAmount.val();

            if (artistFeeAmount !== '' && $artistFeeTotal.val() === '' && $artistFeePercentage.val() === '') {
                $artistFeeTotal.val(artistFeeAmount);
            }

            if ($artistFeeTotal.val() !== '') {
                var newPercentage = $artistFeeTotal.val() - artistFeeAmount;

                $artistFeePercentage.val(newPercentage >= 0 ? newPercentage : '0');
            }

            if ($artistFeePercentage.val() !== '') {
                $artistFeeAmount.val($artistFeeTotal.val() - $artistFeePercentage.val());
            }
        },

        onChangeArtistFeeTotal: function() {
            var $artistFeeTotal = $(this),
                $row = $artistFeeTotal.closest('tr'),
                $artistFeeAmount = $row.find('[data-form-control="artistfee_amount"]'),
                $artistFeePercentage = $row.find('[data-form-control="artistfee_percentage"]'),
                artistFeeTotal = $artistFeeTotal.val();

            if (artistFeeTotal === '') {
                $artistFeeAmount.val('');
                $artistFeePercentage.val('');
            } else {
                if ($artistFeeAmount.val() === '' && $artistFeePercentage.val() === '') {
                    if ($artistFeeAmount.attr('placeholder')) {
                        $artistFeeAmount.val($artistFeeAmount.attr('placeholder'));
                    } else {
                        $artistFeePercentage.val(artistFeeTotal);
                    }
                }

                if ($artistFeeAmount.val() !== '') {
                    var newPercentage = artistFeeTotal - $artistFeeAmount.val();

                    $artistFeePercentage.val(newPercentage >= 0 ? newPercentage : '0');
                }

                if ($artistFeePercentage.val() !== '') {
                    $artistFeeAmount.val(artistFeeTotal - $artistFeePercentage.val());
                }
            }
        },

        onChangeArtistFeePercentage: function() {
            var $artistFeePercentage = $(this),
                $row = $artistFeePercentage.closest('tr'),
                $artistFeeAmount = $row.find('[data-form-control="artistfee_amount"]'),
                $artistFeeTotal = $row.find('[data-form-control="artistfee_total"]'),
                artistFeePercentage = $artistFeePercentage.val();

            if (artistFeePercentage === '') {
                $artistFeeAmount.val($artistFeeTotal.val());
            } else {
                if ($artistFeeAmount.val() === '' && $artistFeeTotal.val() === '') {
                    if ($artistFeeAmount.attr('placeholder')) {
                        $artistFeeAmount.val($artistFeeAmount.attr('placeholder'));
                    } else {
                        $artistFeeTotal.val(artistFeePercentage);
                    }
                }
            }

            if (artistFeePercentage !== '') {
                $artistFeeTotal.val((parseFloat($artistFeeAmount.val()) || 0) + parseFloat(artistFeePercentage));
            } else if ($artistFeeTotal.val() !== '') {
                $artistFeeAmount.val($artistFeeTotal.val());
            }
        }
    };

    var $body = $('body');

    $body.on('app.init', function(ev) {
        var $container = $(ev.container),
            $form = $container.find('form[data-form="ticket-sales-formal-register"]'),
            $periodBeginInputs = $('#representation_period_begin'),
            $periodEndInputs = $('#representation_period_end'),
            $periodAuto = $('#ticket_sales_register_representation_period_auto'),
            $overallInputs = $form.find('[data-form-control="overall"]'),
            $bookingEntries = $form.find('[data-booking-entries]'),
            $artistFeeAmounts = $form.find('[data-form-control="artistfee_amount"]'),
            $artistFeeTotals = $form.find('[data-form-control="artistfee_total"]'),
            $artistFeePercentages = $form.find('[data-form-control="artistfee_percentage"]');

        $overallInputs.on('change', _events.onChangeEntryOverall);
        $periodAuto.on('change', _events.onChangePeriodAuto);
        $periodBeginInputs.on('change', _events.onChangePeriodBegin);
        $periodEndInputs.on('change', _events.onChangePeriodEnd);
        $artistFeeAmounts.on('change', _events.onChangeArtistFeeAmount);
        $artistFeeTotals.on('change', _events.onChangeArtistFeeTotal);
        $artistFeePercentages.on('change', _events.onChangeArtistFeePercentage);
        $bookingEntries
            .on('refresh', _events.onRefreshBookingEntries)
            .trigger('refresh');
    });

}( require('jquery') ));
